import React from "react";
import styled from "styled-components";

const Section = styled.section`
  padding: 4rem 2rem;
  background: #1b1b1b;
  color: #eee;
  text-align: center;
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.primary};
  margin-bottom: 2rem;
  font-size: 2.2rem;
`;

const Table = styled.table`
  width: 90%;
  max-width: 800px;
  margin: auto;
  border-collapse: collapse;
  background: ${({ theme }) => theme.glass};
  border-radius: 12px;
  overflow: hidden;
`;

const Th = styled.th`
  padding: 1rem;
  background: #222;
  color: ${({ theme }) => theme.secondary};
`;

const Td = styled.td`
  padding: 1rem;
  border-bottom: 1px solid #333;
`;

export default function Leaderboard() {
  const leaders = [
    { rank: 1, name: "Ankit Dev", issuesSolved: 120 },
    { rank: 2, name: "Priya Codes", issuesSolved: 108 },
    { rank: 3, name: "Gaurav Fixer", issuesSolved: 97 },
  ];

  return (
    <Section>
      <Title>🔥 Top Solvers This Month</Title>
      <Table>
        <thead>
          <tr>
            <Th>Rank</Th>
            <Th>Name</Th>
            <Th>Issues Solved</Th>
          </tr>
        </thead>
        <tbody>
          {leaders.map((leader, idx) => (
            <tr key={idx}>
              <Td>#{leader.rank}</Td>
              <Td>{leader.name}</Td>
              <Td>{leader.issuesSolved}</Td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Section>
  );
}
